/* unplugin-vue-components disabled */import script from "./LoginPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./LoginPopup.vue?vue&type=script&setup=true&lang=js"

import "./LoginPopup.vue?vue&type=style&index=0&id=da316a32&lang=scss"

const __exports__ = script;

export default __exports__